import * as CD from 'app/cd/models/essette-api';
import { autoinject, bindingMode } from 'aurelia-framework';
import { ComponentBase, SortDirection, Sorting } from 'app/shared/lib/essette-site';
import { bindable } from 'aurelia-typed-observable-plugin';
import { ProviderService } from 'app/cd/services/provider-service';
import { apiCall } from 'app/shared/lib/api/api';
import { SortChangeEvent } from 'app/shared/attributes/sortable-attribute';
import { IQueryLoadOptions } from 'app/shared/lib/api/api-types';
import { EssPagerCustomElement } from 'app/shared/elements/ess-pager';


@autoinject()
export class ProviderSpecialtyGrid extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    @bindable.stringNull({ defaultBindingMode: bindingMode.toView, changeHandler: 'reload' })
    public providerId: string | null = null;

    protected specialties: ReadonlyArray<CD.ProviderSpecialty> | null = [];

    private sorting: Sorting = new Sorting();
    protected resultCount: number = 0;
    protected pageSize: number = 5;

    ////****************** Element References ***************************************////
    protected $pager!: EssPagerCustomElement;


    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly providerService: ProviderService,
        ...rest: any[]) {

        super(...rest);
    }


    ////****************** Events ***************************************************////
    protected async reload(): Promise<void> {
        await this.loadProvider();
    }


    ////****************** Functions ************************************************////
    protected applySort(event: SortChangeEvent): void {
        const { property, direction } = event.detail;
        const { sorting: sorting } = this;
        if (direction === null) {
            sorting.remove(property);
        } else {
            sorting.add({
                reference: property,
                direction: direction === 'asc' ? SortDirection.Ascending : SortDirection.Descending
            });
        }
        this.loadProvider();
    }


    ////****************** Service Calls ********************************************////
    @apiCall
    private async loadProvider(): Promise<void> {
        if(!this.providerId) return;

        const options: Partial<IQueryLoadOptions> = {
            top: this.pageSize,
            page: this.$pager?.page || 0,
            sorting: this.sorting
        };

        try {
            this.state.beginLoad();

            const response = await this.providerService.loadProviderSpecialties(this.providerId, options);
            this.specialties = response.results;
            this.resultCount = response.count || 0;
        } catch (error) {
            throw error;
        } finally {
            this.state.endLoad();
        }
    }
}
